import React, { Component } from 'react'
import Head from 'components/UI/Table/Head'
import ListItem from 'components/UI/Table/ListItem'

interface Props {
  body: any[]
  header: any
  actionBlock: any,
  isNew?: boolean
}
class Table extends Component<Props> {
  render() {
    const { body, header, actionBlock } = this.props
    return (
      <div>
        <Head data={header.columns} showAction={!!actionBlock} />
        {body.map(row => (
          <ListItem
            key={row.id}
            id={row.id}
            data={row.columns}
            hoverData={row.hoverColumns}
            actionBlock={actionBlock}
          />
        ))}
      </div>
    )
  }
}

export default Table
